import layerTemplatesIcon from '@disy/cadenza-icons/layer-templates.svg';

import { LayerAction } from 'cadenza/map/layer-actions/layer-action';
import { LayerProperty } from 'cadenza/map/layer-property';
import { icon } from 'cadenza/utils/icon/icon';
import i18n from 'cadenza/map/layer-actions/layer-actions.properties';
import { isConfigurableWithCurrentMapScale } from 'cadenza/map/layer-utils';

import './show-layer-configuration-menu.css';

// If no templates are applicable but the layer is configurable, opens the config panel directly
export class ShowLayerConfigurationPanel extends LayerAction {

  #map;

  constructor (layer, options) {
    super(layer, {
      label: i18n('mapconfig.showConfigurationMenuButton.label'),
      icon: icon(layerTemplatesIcon),
      ...options
    });

    this.#map = options.map;
  }

  execute (button, event) {
    return import(/* webpackChunkName: "layer-configuration-panel" */ 'cadenza/map/layer-configuration-panel/layer-configuration-panel')
      .then(({ LayerConfigurationPanel }) => {
        if (!this._configPanelAlreadyOpen()) {
          const layerId = this.layer.get(LayerProperty.ID);
          const panel = new LayerConfigurationPanel(layerId, this.#map);
          const container = document.querySelector('#sidebar');
          container.appendChild(panel);
        }
      });
  }

  isExpandable () {
    return false;
  }

  isSupportedSync ({ isEditingLayer, map }) {
    return !isEditingLayer
      && isConfigurableWithCurrentMapScale(this.layer, map)
      && !this.layer.get(LayerProperty.HAS_APPLICABLE_TEMPLATES);
  }

  _configPanelAlreadyOpen () {
    return !!document.querySelector('#sidebar .d-layer-configuration-panel');
  }

}
